import React from "react";
import { css } from "@emotion/react";
import Logo from "core/shared/asset/Logo";
import { Icon, StHeader, StHeaderItem } from "@mediamath/design-system-eng";
import { Colors } from "design-system";
import styled from "@emotion/styled";
import AppFeatureFlags from "core/app/util/AppFeatureFlags";
import AccountSelector from "core/app/presenter/AccountSelector";
import { useSideNav } from "core/app/hooks/useSideNav";
import { HeaderUserTimezone } from "core/app/presenter/HeaderBox";
import { useFlagVariations } from "@flopflip/react-broadcast";
import CommonMessages from "creatives/intl/CommonMessages";
import useFormMessages from "core/pattern/form-hooks/hooks/useFormMessages";

const StAppHeader = styled(StHeader)`
  box-sizing: border-box;
`;

const menuStyle = css`
  width: 16px !important;
  height: 16px !important;
  font-size: 16px !important;
  line-height: 16px !important;
  color: inherit;
`;

const StLeftItems = styled("div")`
  display: flex;
`;

const StAcctSelectorHolder = styled("div")`
  padding: 0 6px;
  display: flex;
  align-items: center;
`;

const StHeaderIcon = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 50px;
  height: 50px;
  transition-property: color, background-color;
  transition-duration: 150ms;
  background-color: ${Colors.White};
  color: ${Colors.Grey900};

  &[data-open="true"] {
    background-color: ${Colors.Grey900};
    color: ${Colors.White};
  }
`;

const StBlockHeader = styled("div")`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-right: 50px;
  padding: 10px;
`;

const StHeaderLink = styled("a")`
  font-size: 18px;
`;

const StLogoHolder = styled("div")`
  display: flex;
  margin-top: 4px;
`;

const MenuToggle = React.memo(() => {
  const { toggleSideNav, collapsed } = useSideNav();
  return (
    <StHeaderIcon onClick={toggleSideNav} data-open={!collapsed}>
      <Icon name="menu-fill" css={[menuStyle]} />
    </StHeaderIcon>
  );
});

MenuToggle.displayName = "MenuToggle";

const renderAccountSelector = (flagState) => {
  switch (flagState) {
    default:
      return null;
    case "v0-org-only":
      return <AccountSelector />;
  }
};

const AppHeader = () => {
  const [SIDE_NAV_FLAG, ACCOUNT_SELECTOR_FLAG] = useFlagVariations([
    AppFeatureFlags.SIDE_NAV,
    AppFeatureFlags.ACCOUNT_SELECTOR,
  ]);
  const { msgs } = useFormMessages(CommonMessages);

  const isExternalPreview = window?.location?.href?.includes(
    "/creative-preview/"
  );

  return (
    <StAppHeader
      backgroundColor="#ffffff"
      paddingLeft={isExternalPreview ? "15px" : "0px"}
      paddingRight="15px"
    >
      <StLeftItems>
        {isExternalPreview ? (
          <StLogoHolder>
            <Logo theme="light" />
          </StLogoHolder>
        ) : (
          <>
            {SIDE_NAV_FLAG && <MenuToggle />}
            <StAcctSelectorHolder>
              {renderAccountSelector(ACCOUNT_SELECTOR_FLAG)}
            </StAcctSelectorHolder>
          </>
        )}
      </StLeftItems>
      <StHeaderItem>
        {isExternalPreview ? (
          <StHeaderLink
            href="https://support.infillion.com/s/"
            target="_blank"
            rel="noreferrer"
          >
            {msgs.MediaMathHelpCenter}
          </StHeaderLink>
        ) : (
          <>
            <StBlockHeader>
              <HeaderUserTimezone />
            </StBlockHeader>
            <StLogoHolder>
              <Logo theme="light" />
            </StLogoHolder>
          </>
        )}
      </StHeaderItem>
    </StAppHeader>
  );
};

export default AppHeader;
